import { PanelEntity } from '../../../components/PanelEntity/PanelEntity';
import { EntityType } from '../../../components/EntityDetailPopup/entityDetailPopup.enums';

export function TasksPage() {
	return <PanelEntity entityType={EntityType.Task} />;
}
